import React from "react";

import "../../styles/components/number.scss";

const ANIMATION_DURATION_IN_SECONDS = 0.25;
const DEFAULT_NUM_DIGITS = 4;

export default class Number extends React.Component {
  constructor() {
    super();

    /**
     * @type {{
     *  runAnimation: boolean
     * }}
     */
    this.state = {
      runAnimation: false,
    };

    this.select = this.select.bind(this);
  }

  render() {
    /**
     * @type {{
     *  children: React.ReactNode,
     *  readonly: boolean,
     *  number: number,
     *  disabled: boolean,
     *  selected: boolean,
     * }}
     */
    const { children, readonly, number, numberLength, disabled, selected } =
      this.props;
    const { runAnimation } = this.state;

    return (
      <React.Fragment>
        <button
          onClick={this.select}
          className={`number ${
            runAnimation ? "number--select-animation" : ""
          } ${readonly ? "number--readonly" : ""} ${
            selected ? "number--selected" : ""
          }`}
          disabled={disabled}
        >
          {number == null
            ? children
            : number
                .toString()
                .padStart(numberLength || DEFAULT_NUM_DIGITS, "0")}
        </button>
      </React.Fragment>
    );
  }

  select() {
    const { onClick, selected } = this.props;

    this.setState({
      ...this.state,
      runAnimation: !selected,
    });

    setTimeout(() => {
      this.setState({
        ...this.state,
        runAnimation: false,
      });
    }, ANIMATION_DURATION_IN_SECONDS * 1000);

    onClick();
  }
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/number.jsx